import React from 'react';
import { aboutStatement } from '../data/landing';
type Segment = {
  text: string;
  strong: boolean;
};
export function Statement() {
  return <section id="studio" className="px-page" data-id="element-375" data-mp="14699z2lfgg1z">
      <div className="w-full" data-id="element-376" data-mp="195c6fyncddyc">
        {/* About */}
        <div className="pb-10 pt-20 md:pb-14 md:pt-28" data-id="element-377" data-mp="193so82i4kstx">
          <h2 className="sr-only" data-id="element-378" data-mp="1d6xnlw6wseec">About Laebel</h2>
          <p className="max-w-[640px] font-serif text-[36px] font-normal leading-[1.08] tracking-[-0.01em] text-fg md:text-[48px] [text-wrap:pretty]" data-id="element-379" data-mp="1d4ky8xytn1r9">
            <Segments segments={aboutStatement} data-id="element-380" data-mp="1n43eb3bm23e1" />
          </p>
        </div>
      </div>
    </section>;
}
function Segments({
  segments
}: {
  segments: Segment[];
}) {
  return <>
      {segments.map((s, i) => s.strong ? <span key={i} className="text-fg/40" data-id="element-381" data-mp="1wtvfige7turh">
            {s.text}
          </span> : <span key={i} data-id="element-382" data-mp="20u6updnt72vk">{s.text}</span>)}
    </>;
}